import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Step,
  StepHeading,
  StepContent,
  Label,
  Input,
  Select,
  SettingsCollapse,
  StepOptionCard,
  Button,
  InputGroup,
  Radio,
  PlusButton,
  ScrollContainer,
  ModalSummary,
  MoreText as DefaultMoreText,
} from 'prospect-path-components';
import { connect } from 'react-redux';
import first from 'lodash/first';
import cloneDeep from 'lodash/cloneDeep';

import RadioContainer from '../../radio-container';
import DataGroupChecklist from '../../data-group-checklist';
import ErrorText from '../../ErrorText';
import pick from '../../../../tools/pick';

const FeatureList = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const MoreText = styled(DefaultMoreText)`
  margin-left: 0.5rem;
`;

class PlanFeaturesSupportStep extends Component {
  constructor(props) {
    super(props);

    this.state = {
      advancedSettingsOpen: false,
      expandLimits: false,
      initialLimit: {
        check: null,
        value: null,
        subject: null,
      },
      data: {
        support_included: null,
        limits: [],
        features: [],
      },
    };

    this.handleNextButtonClicked = this.handleNextButtonClicked.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.toggleAdvancedSettings = this.toggleAdvancedSettings.bind(this);
    this.toggleExpandLimitsCard = this.toggleExpandLimitsCard.bind(this);
    this.addLimit = this.addLimit.bind(this);
    this.deleteLimit = this.deleteLimit.bind(this);
    this.handleDataGroups = this.handleDataGroups.bind(this);
  }
  componentWillMount() {
    const { checks, subjects } = this.props.pricing.limits;
    const { initialLimit, data } = this.state;
    const { limits } = data;

    initialLimit.check = first(Object.keys(checks));
    initialLimit.subject = first(Object.keys(subjects));
    initialLimit.value = 0;

    if (!this.props.plan) {
      limits.push(initialLimit);
      data.limits = limits;
    }

    this.setState({ initialLimit, data });

    if (this.props.plan) {
      const { data } = this.state;
      const { features, limits: planLimits } = this.props.plan;
      const advancedSettingsOpen = planLimits.length > 0;
      const expandLimits = planLimits.length > 0;
      const initialLimit = cloneDeep(this.state.initialLimit);

      data.features = features;
      data.limits = planLimits.length > 0 ? planLimits : [{ ...initialLimit }];

      this.setState({ data, advancedSettingsOpen, expandLimits });
    }
  }
  handleNextButtonClicked() {
    const state = { ...this.state };
    const data = cloneDeep(state.data);

    data.limits = state.expandLimits ? data.limits : [];

    this.props.onNextButtonClicked(data);
  }
  toggleAdvancedSettings() {
    this.setState({ advancedSettingsOpen: !this.state.advancedSettingsOpen });
  }
  toggleExpandLimitsCard() {
    this.setState({ expandLimits: !this.state.expandLimits });
  }
  getChecks() {
    const checks = this.props.pricing.limits.checks || {};

    return Object.entries(checks).map(check => ({
      value: check[0],
      text: check[1],
    }));
  }
  getSubjects() {
    const subjects = this.props.pricing.limits.subjects || {};

    return Object.entries(subjects).map(subject => ({
      value: subject[0],
      text: subject[1],
    }));
  }
  addLimit() {
    const { initialLimit, data } = this.state;
    const { limits } = data;

    limits.push(initialLimit);
    data.limits = limits;

    this.setState({ data });
  }
  deleteLimit(index) {
    const { data } = this.state;
    const { limits } = data;

    data.limits = limits.filter((limits, limitsIndex) => limitsIndex !== index);

    this.setState({ data });
  }
  handleDataGroups(id, checkedItems) {
    const { data } = this.state;
    data.features = checkedItems;

    this.setState({ data });
  }
  handleChange(e) {
    const { data } = { ...this.state };
    const { name, value } = e.target;
    data[name] = value;

    this.setState({ data });
  }
  handleLimitsChange(e, index) {
    const { name, value } = e.target;
    const { data } = { ...this.state };
    const { limits } = data;
    const limitIndex = limits.findIndex((additionalCost, additionalCostsIndex) => additionalCostsIndex === index);
    const limit = { ...limits[limitIndex] };
    limit[name] = value;

    limits.splice(limitIndex, 1, limit);

    data.limits = limits;

    this.setState({ data });
  }
  getFeatures() {
    return this.props.dataGroups.find(dataGroup => dataGroup.slug === 'features');
  }
  errorsForField(field) {
    if (this.props.errors[field]) {
      return this.props.errors[field].map(error => <ErrorText>{error}</ErrorText>);
    }

    return '';
  }
  errorsForLimit(index, field) {
    const limit = pick(this.props.errors, ['limits', index], false);
    if (!limit) {
      return '';
    }

    return limit[field].map(error => <ErrorText>{error}</ErrorText>);
  }
  render() {
    const features = this.getFeatures();
    const featureValues = this.props.getFeatureDataValues();

    return (
      <Step>
        <StepHeading
          number={2}
          disabled={this.props.disabled}
          showEditButton={this.props.showEditButton}
          onEditButtonClicked={this.props.onEditButtonClicked}
        >
          Plan Features & Support
        </StepHeading>

        {!this.props.isOpened && (
          <ModalSummary>
            <div style={{ display: 'flex', whiteSpace: 'nowrap' }}>
              <FeatureList>
                {this.state.data.features
                  .map(feature => feature.name)
                  .slice(0, 3)
                  .join(', ')
                }
              </FeatureList>

              {this.state.data.features.length > 4 && (
                <MoreText number={this.state.data.features.length - 3} />
              )}
            </div>

            <div>
              {this.state.data.support_included === 'true' && (<span>Support included</span>)}
              {!this.state.data.support_included === 'false' && (<span>No support included</span>)}
            </div>
          </ModalSummary>
        )}

        <StepContent isOpened={this.props.isOpened}>
          <div style={{ marginTop: '1.25rem' }}>
            {this.errorsForField('features')}
            {features && featureValues.length > 0 && (
              <ScrollContainer>
                <DataGroupChecklist
                  id={features.id}
                  label={features.name}
                  options={featureValues}
                  showSelectAllNone={false}
                  onChange={this.handleDataGroups}
                  defaultValues={this.state.data.features}
                  disabled={this.props.readOnly}
                />
              </ScrollContainer>
            )}

            <InputGroup>
              {this.errorsForField('support_included')}
              <Label>Support Included</Label>
              <RadioContainer>
                <Radio
                  onChange={this.handleChange}
                  name="support_included"
                  value="true"
                  label="Yes"
                  disabled={this.props.readOnly}
                />
                <Radio
                  onChange={this.handleChange}
                  name="support_included"
                  value="false"
                  label="No"
                  disabled={this.props.readOnly}
                />
              </RadioContainer>
            </InputGroup>

            <SettingsCollapse
              isOpened={this.state.advancedSettingsOpen}
              label="Show advanced settings"
              onClick={this.toggleAdvancedSettings}
            >
              <div>
                {this.state.data.limits.map((limit, index) => (
                  <StepOptionCard
                    key={index}
                    title={index === 0 ? 'Limits' : null}
                    showSwitch={index === 0}
                    switchProps={{ onChange: this.toggleExpandLimitsCard, checked: this.state.expandLimits }}
                    isOpened={this.state.expandLimits}
                    style={{ display: (index === 0 || this.state.expandLimits) ? 'block' : 'none' }}
                    showRemoveButton={index !== 0}
                    onRemoveButtonClicked={() => this.deleteLimit(index)}
                  >
                    <div style={{ display: 'flex' }}>
                      <InputGroup horizontal style={{ flex: 1 }}>
                        {this.errorsForLimit(index, 'subject')}
                        <Label>Limit Subject</Label>
                        <Select
                          value={this.state.data.limits[index].subject}
                          name="subject"
                          onChange={e => this.handleLimitsChange(e, index)}
                          disabled={this.props.readOnly}
                        >
                          {this.getSubjects()
                            .filter(({value}) => {
                              const valueIsPhysician = value === 'PHYSICIAN';
                              const categoriesIncludesEhr = this.props.categories
                                .map(category => category.slug)
                                .includes('ehr');

                              return !(valueIsPhysician && !categoriesIncludesEhr);
                            })
                            .map(({ value, text }) => (
                              <option key={value} value={value}>{text}</option>
                            ))}
                        </Select>
                      </InputGroup>
                      <InputGroup horizontal style={{ flex: 1 }}>
                        {this.errorsForLimit(index, 'check')}
                        <Label>Condition</Label>
                        <Select
                          value={this.state.data.limits[index].check}
                          name="check"
                          onChange={e => this.handleLimitsChange(e, index)}
                          disabled={this.props.readOnly}
                        >
                          {this.getChecks()
                            .map(({ value, text }) => (
                              <option key={value} value={value}>{value.toLowerCase().replace(/_/g, ' ')}</option>
                            ))}
                        </Select>
                      </InputGroup>
                      <InputGroup horizontal style={{ flex: 1 }}>
                        {this.errorsForLimit(index, 'value')}
                        <Label>Limit Value</Label>
                        <Input
                          type="number"
                          value={this.state.data.limits[index].value}
                          name="value"
                          onChange={e => this.handleLimitsChange(e, index)}
                          disabled={this.props.readOnly}
                        />
                      </InputGroup>
                    </div>
                  </StepOptionCard>
                ))}
              </div>
              {this.state.expandLimits && <PlusButton disabled={this.props.readOnly} style={{ backgroundColor: 'white' }} onClick={this.addLimit}>Add Limit</PlusButton>}
            </SettingsCollapse>

            <div style={{ marginTop: '1.25rem' }}>
              <Button
                color="secondary"
                onClick={this.handleNextButtonClicked}
              >
                Continue
              </Button>
            </div>
          </div>
        </StepContent>
      </Step>
    );
  }
}

PlanFeaturesSupportStep.propTypes = {
  categories: PropTypes.array.isRequired,
  isOpened: PropTypes.bool,
  disabled: PropTypes.bool,
  onNextButtonClicked: PropTypes.func.isRequired,
  showEditButton: PropTypes.bool,
  onEditButtonClicked: PropTypes.func,
  getFeatureDataValues: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

PlanFeaturesSupportStep.defaultProps = {
  isOpened: false,
  disabled: true,
  showEditButton: false,
  onEditButtonClicked: () => {},
  readOnly: false,
};

const mapStateToProps = state => ({
  pricing: state.productManagement.pricing.all,
  dataGroups: state.productManagement.dataGroups.all,
});

export default connect(mapStateToProps)(PlanFeaturesSupportStep);
